var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconMerge = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", stroke: props.color, strokeWidth: "2.167", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", null,
                React.createElement("path", { d: "M13.6,26c-1.2,0-2.2-1-2.2-2.2V18H6.6c-1.2,0-2.2-1-2.2-2.2V6.1c0-1.2,1-2.2,2.2-2.2\n\t\th9.8c1.2,0,2.2,1,2.2,2.2V12h4.8c1.2,0,2.2,1,2.2,2.2V24c0,1.2-1,2.2-2.2,2.2h-9.8V26z" }),
                React.createElement("g", { transform: "translate(2.401 2.126)" },
                    React.createElement("path", { d: "M7.4,11.4h4.5V6.9" }),
                    React.createElement("path", { d: "M11.9,11.4L6.5,6" })),
                React.createElement("g", { id: "Gruppe_1215_1_", transform: "translate(2.401 2.126)" },
                    React.createElement("path", { d: "M18.3,14.5h-4.4v4.4" }),
                    React.createElement("path", { d: "M13.9,14.5l5.3,5.3" }))))));
});
export default IconMerge;
//# sourceMappingURL=IconMerge.js.map